import React from "react";

import { Close } from "components/Icons";

const FilesList = ({ files, removeCallback }) => (
  <div className="files-list">
    {files.map((f, i) => (
      <div key={i} className="filename">
        {f.name || f} <Close onClick={() => removeCallback(i)} />
      </div>
    ))}
  </div>
);

export default FilesList;
